import { render, staticRenderFns } from "./job.vue?vue&type=template&id=0605b4d8&scoped=true"
import script from "./job.vue?vue&type=script&lang=js"
export * from "./job.vue?vue&type=script&lang=js"
import style0 from "./job.vue?vue&type=style&index=0&id=0605b4d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0605b4d8",
  null
  
)

export default component.exports